import { UI, Button, Stack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { ApplicationRangeFormData, applicationRangeDefault, objectIsEquals } from '../..';

interface FooterProps {
  buttonCleanIsDisabled: boolean;
  buttonApplyIsDisabled: boolean;
  handleCleanFilters: () => void;
  handleApplyFilters: () => void;
  currentApplicationRanges: {
    min: number;
    max: number;
  };
}
export const Footer: React.FC<FooterProps> = ({
  buttonApplyIsDisabled,
  buttonCleanIsDisabled,
  handleCleanFilters,
  handleApplyFilters,
  currentApplicationRanges,
}) => {
  const { control } = useFormContext<ApplicationRangeFormData>();

  const minAppliedAmount = useWatch({
    control,
    name: 'minAppliedAmount',
  });

  const maxAppliedAmount = useWatch({
    control,
    name: 'maxAppliedAmount',
  });

  const applicationRangeIsChanged = objectIsEquals(
    {
      min: Utils.Unmask.Money(minAppliedAmount),
      max: Utils.Unmask.Money(maxAppliedAmount),
    },
    currentApplicationRanges
  );

  const applicationRangeIsDefaultValue = objectIsEquals(
    {
      min: Utils.Unmask.Money(minAppliedAmount),
      max: Utils.Unmask.Money(maxAppliedAmount),
    },
    applicationRangeDefault
  );

  const buttonCleanFiltersIsDisabled = buttonCleanIsDisabled && applicationRangeIsDefaultValue;
  const isError = Utils.Unmask.Money(minAppliedAmount) > Utils.Unmask.Money(maxAppliedAmount);
  const direction = useBreakpointValue({ base: 'column', lg: 'row' });
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  return (
    <Stack
      direction={direction}
      backgroundColor={Color['neutral.white']}
      alignItems={'center'}
      justifyContent={'space-between'}
      p={Spacing['inline.xxs']}
      space={Spacing['inline.nano']}
      borderTopWidth={1}
      borderTopColor={Color['neutral.lightest']}
      {...(!isDesktop && { w: 'full' })}>
      <Button
        variant={'textLink'}
        isDisabled={buttonCleanFiltersIsDisabled}
        {...(!buttonCleanFiltersIsDisabled && { _text: { color: 'feedback.error.default' } })}
        {...(buttonCleanFiltersIsDisabled && { _text: { color: 'neutral.light' } })}
        {...(!isDesktop && { w: 'full' })}
        onPress={handleCleanFilters}
        rightIcon={
          <UI.Icon
            testId="testID"
            name="Trash"
            {...(!buttonCleanFiltersIsDisabled && { color: Color['feedback.error.default'] })}
            {...(buttonCleanFiltersIsDisabled && { color: Color['neutral.light'] })}
            size="xxs"
          />
        }>
        Remover Filtros
      </Button>
      <Button
        {...(!isDesktop && { w: 'full' })}
        variant={'primary'}
        isDisabled={buttonApplyIsDisabled && (applicationRangeIsChanged || isError)}
        onPress={handleApplyFilters}>
        Aplicar filtros
      </Button>
    </Stack>
  );
};
